import { GtmEvents } from '@/gtm/gtm-events';

export class HeaderGtmEvents extends GtmEvents {
  eventCategory = 'СобытияВХедере';

  clickMenuItem({ path = [] }) {
    return this.gtmEvent({
      eventAction: 'Меню_КликПоМеню',
      eventLabel: path.join(' / '),
    });
  }
}

export const headerGtmEvents = new HeaderGtmEvents();
